var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_c('div',[_vm._v("排班制员工使用。换班审批通过后，考勤排班表里的班次自动调换。")])])
}]

export { render, staticRenderFns }